import { Data_getInstance3o5yzdnbrsag5 as Data_getInstance } from './adapter/SaveBoostMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SaveBoostMutationSelections_getInstance1exiso4dqvyol as SaveBoostMutationSelections_getInstance } from './selections/SaveBoostMutationSelections.mjs';
import { SaveBoostMutation_VariablesAdapter_instance28d040njnt0ii as SaveBoostMutation_VariablesAdapter_instance } from './adapter/SaveBoostMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveBoost) {
        this.a6g_1 = saveBoost;
      }
      toString() {
        return 'Data(saveBoost=' + this.a6g_1 + ')';
      }
      hashCode() {
        return this.a6g_1 == null ? 0 : getBooleanHashCode(this.a6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.a6g_1 == other.a6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.b6g_1 = obj(Data_getInstance());
        this.c6g_1 = (new (Builder())('data', Companion_getInstance().o6d_1)).s43(SaveBoostMutationSelections_getInstance().f6g_1).i37();
        this.d6g_1 = 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
        this.e6g_1 = 'saveBoost';
      }
      r6d() {
        return 'mutation saveBoost($input: SaveBoostInput!) { saveBoost(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SaveBoostMutationClass;
function SaveBoostMutation() {
  if (SaveBoostMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.g6g_1 = input;
      }
      t6d() {
        return 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
      }
      operationId() {
        return this.t6d();
      }
      l47() {
        return Companion_getInstance_0().r6d();
      }
      u6d() {
        return 'saveBoost';
      }
      operationName() {
        return this.u6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        SaveBoostMutation_VariablesAdapter_instance.h6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return Companion_getInstance_0().b6g_1;
      }
      toString() {
        return 'SaveBoostMutation(input=' + this.g6g_1.toString() + ')';
      }
      hashCode() {
        return this.g6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveBoostMutation()))
          return false;
        if (!this.g6g_1.equals(other.g6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveBoostMutation', VOID, VOID, [Mutation()]);
    SaveBoostMutationClass = $;
  }
  return SaveBoostMutationClass;
}
//region block: exports
export {
  Data as Data20ir384tdyz1e,
  SaveBoostMutation as SaveBoostMutation360x4uh5hti27,
};
//endregion

//# sourceMappingURL=SaveBoostMutation.mjs.map
